// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_VkV","cls2":"RelatedPapers-cls2_Df9 RelatedPapers-cls1_VkV"};